package com.damda.design_system.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.damda.design_system.ui.views.compose_migrations.images.ResizableJSImage
import com.damda.design_system.ui.views.compose_migrations.layouts.AppBar
import com.damda.design_system.ui.views.compose_migrations.layouts.JSSpacer
import com.damda.design_system.ui.views.compose_migrations.layouts.QuantitySelector
import com.damda.design_system.ui.views.compose_migrations.layouts.WidthFullSizeButton
import com.damda.design_system.ui.views.core.ComposeWindowWidthSizeClass
import com.damda.design_system.ui.views.core.JSViewPadding
import com.damda.design_system.ui.views.foods.FoodDetailDescription
import com.damda.design_system.ui.views.foods.FoodDetailTitle
import com.damda.design_system.ui.views.lists.FoodItem
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.events.Event

@Composable
fun FoodDetailScreen(
    windowSize: ComposeWindowWidthSizeClass,
    foodItem: FoodItem,
    itemCount: MutableState<Int> = mutableStateOf(1),
    onBackArrowClick: () -> Unit,
    onClickAddCartButton: (FoodItem, Int) -> Unit,
) {
    var reduceFontSize by remember { mutableStateOf(0.px) }

    val newFontSize = when (windowSize) {
        ComposeWindowWidthSizeClass.Small -> 4.px
        ComposeWindowWidthSizeClass.Medium -> 2.px
        ComposeWindowWidthSizeClass.Large -> 0.px
        else -> {0.px}
    }
    reduceFontSize = newFontSize

    Div(
        attrs = {
            style {
                width(100.percent)
                height(100.percent)
                overflowY("scroll")
            }
        }
    ) {
        JSSpacer(height = 12.px)
        AppBar("Food Detail", onBackArrowClick)
        JSSpacer(height = 20.px)
        Div {
            ResizableJSImage(
                imageName = foodItem.imageName,
                minWidth = 373.px,
                radius = 20.px,
                padding = JSViewPadding(24.px, 0.px, 24.px, 0.px)
            )
        }
        JSSpacer(height = 20.px)
        Div(
            attrs = {
                style {
                    padding(0.px, 24.px)
                }
            }
        ) {
            Div ({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.SpaceBetween)
                }
            }){
                FoodDetailTitle(foodItem.title, foodItem.subtitle)
                QuantitySelector(itemCount.value, isDecrementFilter = itemCount.value > 1, onIncrement = { itemCount.value += 1 }, onDecrement = { itemCount.value -= 1 })
            }
            JSSpacer(height = 24.px)
            FoodDetailDescription(foodItem.detail, foodItem.ingredients)
            JSSpacer(height = 16.px)
            WidthFullSizeButton(
                title = "장바구니 추가하기",
                onClick = { onClickAddCartButton(foodItem, itemCount.value) },
                reduceFontSize = reduceFontSize
            )
            JSSpacer(height = 24.px)
        }
    }
}
